export default "__VITE_ASSET__C89$UboM__"